import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// Used for the partner-scoped router.
// OR semantics across the three entries:
//   1. Global toggle on  → existing behaviour (rt_rfm_v2_retailer_enabled globally enabled)
//   2. Warehouse toggle  → per-warehouse opt-in during selective rollout
//   3. Platform ≥ 2026_07 AND override off → broader enablement; disable override toggle to kill rollout
// `restrictedBannersAllowed: true` mirrors the legacy `retailerFundedMarketingHomeNavAccessControl`
// this replaced — without it, Costco Spain/France (restricted banners 9176/9177) lose Campaigns.
export const marketingToolingAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.MarketingToolingViewAccess],
    featureToggles: [FeatureToggle.marketingToolingRetailerEnabled],
    restrictedBannersAllowed: true,
  },
  {
    permissions: [Permission.MarketingToolingViewAccess],
    warehouseFeatureToggles: [FeatureToggle.marketingToolingRetailerEnabled],
    restrictedBannersAllowed: true,
  },
  {
    permissions: [Permission.MarketingToolingViewAccess],
    notFeatureToggles: [FeatureToggle.marketingToolingRetailerDisabledOverride],
    minICPlatformVersion: ICPlatformVersion.r2026_07_0,
    restrictedBannersAllowed: true,
  },
]
